// import curr from "./currencies.json";

import { Currencies } from "@fresh8/types/src/language";

const curr = {
  GBP: {
    territory: "United Kingdom",
    currency: "Pound",
    symbol: "£",
    code: "GBP",
    fractionUnit: "Pence",
    basicNumber: "100",
    languageCode: "en-GB"
  },
  SEK: {
    territory: "Sweden",
    currency: "Swedish Krona",
    symbol: "kr",
    code: "SEK",
    fractionUnit: "Öre",
    basicNumber: "100",
    languageCode: "sv"
  },
  EUR: {
    territory: "Europe",
    currency: "Euro",
    symbol: "€",
    code: "EUR",
    fractionUnit: "Cent",
    basicNumber: "100",
    languageCode: "de"
  },
  USD: {
    territory: "United States of America",
    currency: "United States Dollar",
    symbol: "$",
    code: "USD",
    fractionUnit: "Cent",
    basicNumber: "100",
    languageCode: "en-US"
  },
  BRL: {
    territory: "Brazil",
    currency: "Brazilian Real",
    symbol: "R$",
    code: "BRL",
    fractionUnit: "Centavo",
    basicNumber: "100",
    languageCode: "pt-BR"
  },
  INR: {
    territory: "India",
    currency: "Indian Rupee",
    symbol: "₹",
    code: "INR",
    fractionUnit: "Paisa",
    basicNumber: "100",
    languageCode: "en"
  },
  NGN: {
    territory: "Nigeria",
    currency: "Nigerian Naira",
    symbol: "₦",
    code: "NGN",
    fractionUnit: "Kobo",
    basicNumber: "100",
    languageCode: "en"
  },
  GHS: {
    territory: "Ghana",
    currency: "Ghanaian Cedi",
    symbol: "Gh₵",
    code: "GHS",
    fractionUnit: "Pesewa",
    basicNumber: "100",
    languageCode: "EE"
  },
  ZMK: {
    territory: "Zambia",
    currency: "Zambian Kwacha",
    symbol: "",
    code: "ZMK",
    fractionUnit: "Ngwee",
    basicNumber: "100",
    languageCode: "en"
  },
  TZS: {
    territory: "Tanzania",
    currency: "Tanzanian Shilling",
    symbol: "ZK",
    code: "TZS",
    fractionUnit: "Senti",
    basicNumber: "100",
    languageCode: "sw"
  },
  CDF: {
    territory: "Congo",
    currency: "Congolese Franc",
    symbol: "FC",
    code: "CDF",
    fractionUnit: "Centime",
    basicNumber: "100",
    languageCode: "fr"
  },
  MZN: {
    territory: "Mozambique",
    currency: "Mozambican Metical",
    symbol: "MT",
    code: "MZN",
    fractionUnit: "Centavos",
    basicNumber: "100",
    languageCode: "pt"
  },
  MMK: {
    territory: "Malawi",
    currency: "Malawian Kwacha",
    symbol: "MK",
    code: "MMK",
    fractionUnit: "Tambala",
    basicNumber: "100",
    languageCode: "en"
  },
  ETB: {
    territory: "Ethiopia",
    currency: "Ethiopian Birr",
    symbol: "Br",
    code: "ETB",
    fractionUnit: "Santim",
    basicNumber: "100",
    languageCode: "am"
  }
};

/**
 * Returns an object containing the currencies available.
 */
export const currencies = curr as Currencies;

/**
 * Formats the number informed based on the currency code
 */
function formatCurrency(
  code: string,
  number: number,
  forceUseCurrencySymbol: boolean
): string {
  const { code: currency } = (curr as Currencies)[code] || {
    languageCode: "en-GB",
    code: "GBP"
  };
  let formattedParts;
  try {
    formattedParts = new Intl.NumberFormat(navigator.language, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      currencyDisplay: "narrowSymbol",
      notation: "compact",
      compactDisplay: "short",
      maximumSignificantDigits: 3
    }).formatToParts(number);
  } catch (err) {
    formattedParts = new Intl.NumberFormat(navigator.language, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      currencyDisplay: "symbol",
      maximumSignificantDigits: 3
    }).formatToParts(number);
  }

  const formatted = formattedParts
    .map(formattedPart => {
      const { type, value } = formattedPart;
      const shouldIgnoreCurrency =
        type === "currency" && value.length >= 3 && !forceUseCurrencySymbol;
      if (shouldIgnoreCurrency) {
        return "";
      }
      return value;
    })
    .join("")
    .trim();

  return formatted;
}

export default formatCurrency;
